import { useCallback, useState, KeyboardEvent } from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

import * as L from './Login.style';
import { onChangeEventType } from '@utils/types';
import useEnter from '@hooks/useEnter';
import { userLogin } from '@modules/authentication';
import { ADMIN_LOGIN } from '@graphql/mutations';
import { Mutation } from '@graphql/types';

import { FlexBox } from '@components/styled/StyledComponents';
import StyledInput from '@components/styled/StyledInput';
import StyledPassword from '@components/styled/StyledPassword';
import StyledButton from '@components/styled/StyledButton';

const Login = () => {
    const onEnter = useEnter();
    const [inputs, setInputs] = useState({
        email: '',
        password: ''
    });

    const [adminLogin] = useMutation<Pick<Mutation, 'adminLogin'>>(ADMIN_LOGIN);

    const onChange = useCallback(
        (e: onChangeEventType) => {
            const { name, value } = e.target;

            setInputs({
                ...inputs,
                [name]: value
            });
        },
        [inputs]
    );

    const handleLogin = async () => {
        const { email, password } = inputs;

        if (email === '' || password === '') {
            toast.warning('로그인 정보를 입력해주세요.');
            return;
        }
        try {
            await adminLogin({
                variables: {
                    account: email,
                    password
                },
                onCompleted: (data) => {
                    userLogin(data.adminLogin as string);
                }
            });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <L.LoginForm>
            <L.Title>로그인</L.Title>
            <L.SubTitle>펫이닷 관리자 페이지입니다</L.SubTitle>
            <StyledInput
                name="email"
                value={inputs.email}
                onChange={onChange}
                placeholder="이메일"
                margin="0 0 8px"
                borderRadius={0}
            />
            <StyledPassword
                name="password"
                value={inputs.password}
                onChange={onChange}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                    onEnter(e, handleLogin)
                }
                placeholder="비밀번호"
                margin="0 0 12px"
                borderRadius={0}
            />
            <FlexBox $justifyContent="flex-end" $alignItems="center">
                <L.LinkButton to="/find/email">이메일 찾기</L.LinkButton>
                <L.LinkButton to="/find/password">비밀번호 찾기</L.LinkButton>
            </FlexBox>
            <StyledButton
                title="로그인"
                margin="32px 0"
                width={343}
                fontSize={14}
                fontFamily="PretendardRegular"
                onClick={handleLogin}
                borderRadius={0}
            />
        </L.LoginForm>
    );
};

export default Login;
